<template>
  <div class="service-box">
    <div class="service-box--img">
      <figure>
        <img
          class="icon"
          alt="Vue logo"
          :src="service.image"
        />
      </figure>
    </div>
    <div class="service-box--title">{{service.title}}</div>
    <div class="service-box--desc">{{service.desc}}</div>
  </div>
</template>

<script>
export default {
  name: 'ServicesBox',
  props: ['service']
}
</script>

<style lang="scss">
@import "~@/styles/variables.scss";
.service-box{
  background-color: $white;
  padding: 5rem 3rem;
  min-height: 33rem;
}

.service-box--title {
  font-size: 1.4rem;
  text-transform: uppercase;
  font-weight: bold;
  margin: 2rem;
}

.service-box--desc {
  font-size: 1.4rem;
  text-transform: uppercase;
}

.service-box{
  background-color: $white;
  padding: 5rem 3rem;
}
</style>
